import { render, staticRenderFns } from "./MediacontactPartnerEdit.vue?vue&type=template&id=3d80fe18"
import script from "./MediacontactPartnerEdit.vue?vue&type=script&lang=js"
export * from "./MediacontactPartnerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports